import { cn } from "@/lib/utils";

export function MedalIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-[13px]", className)}
      viewBox="0 0 13 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.74.134A.294.294 0 0012.493 0H8.037a.294.294 0 00-.268.174L6.125 3.827a.294.294 0 000 .242L7.58 7.303a.294.294 0 00.268.174h1.546c.116 0 .22-.068.268-.174l3.1-6.888a.295.295 0 00-.022-.28z"
        fill="#d62d2d"
      />
      <path
        d="M6.762 2.412l-.637 1.415a.294.294 0 000 .242L7.58 7.303a.294.294 0 00.268.174H9.04L6.762 2.412z"
        fill="#9e1219"
      />
      <path
        clipRule="evenodd"
        d="M5.277 8.004a1.117 1.117 0 002.232 0 1.117 1.117 0 00-2.232 0zm.59 0a.528.528 0 111.055.001.528.528 0 01-1.056 0z"
        fill="#ffa035"
        fillRule="evenodd"
      />
      <path
        d="M8.117 7.062L5.018.174A.294.294 0 004.75 0H.294a.294.294 0 00-.268.415l3.099 6.888a.294.294 0 00.268.174h4.456a.294.294 0 00.268-.415z"
        fill="#ff3d43"
      />
      <path
        d="M6.921 7.477h.927a.294.294 0 00.269-.415L5.018.174A.294.294 0 004.75 0H3.558L6.92 7.477z"
        fill="#d72e2e"
      />
      <path
        d="M6.402 8.532a5.74 5.74 0 00-5.734 5.734A5.74 5.74 0 006.402 20a5.74 5.74 0 005.734-5.734 5.74 5.74 0 00-5.734-5.734z"
        fill="#ffc850"
      />
      <path
        d="M6.402 8.532c-.232 0-.46.014-.686.04a5.742 5.742 0 015.05 5.694 5.742 5.742 0 01-5.05 5.693 5.74 5.74 0 006.42-5.693 5.74 5.74 0 00-5.734-5.734z"
        fill="#f4b70c"
      />
      <path
        d="M6.402 10.108a4.163 4.163 0 00-4.158 4.158 4.163 4.163 0 004.158 4.158 4.163 4.163 0 004.158-4.158 4.163 4.163 0 00-4.158-4.158z"
        fill="#fff5cf"
      />
      <path
        d="M6.402 10.108c-.22 0-.434.017-.644.05a4.165 4.165 0 013.513 4.108 4.164 4.164 0 01-3.513 4.108 4.163 4.163 0 004.802-4.108 4.163 4.163 0 00-4.158-4.158z"
        fill="#ffeca1"
      />
      <path
        d="M8.76 14.12a.66.66 0 00.168-.68.66.66 0 00-.536-.452l-.925-.134a.075.075 0 01-.056-.041l-.414-.838a.66.66 0 00-.595-.37.66.66 0 00-.596.37l-.413.838a.075.075 0 01-.057.04l-.924.135a.66.66 0 00-.536.452.66.66 0 00.168.68l.669.653a.075.075 0 01.021.066l-.158.921a.66.66 0 00.265.65.662.662 0 00.699.05l.827-.435a.075.075 0 01.07 0l.827.435a.66.66 0 00.699-.05.66.66 0 00.264-.65l-.158-.92a.075.075 0 01.022-.067l.669-.652z"
        fill="#ffa035"
      />
      <path
        d="M8.76 14.12a.66.66 0 00.168-.68.66.66 0 00-.536-.452l-.045-.006-1.349 1.297a.37.37 0 00-.106.327l.31 1.822.062.032a.66.66 0 00.699-.05.66.66 0 00.264-.65l-.158-.92a.075.075 0 01.022-.067l.669-.652z"
        fill="#f78819"
      />
      <path
        d="M10.257 7.477H2.53a.294.294 0 010-.589h7.727a.294.294 0 110 .589z"
        fill="#ffc850"
      />
    </svg>
  );
}
